import type { Model } from 'modules/core/lib/mobx-rest'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import { useResourceField } from 'modules/custom_resources/components/CustomFields/CustomFieldsBlock/useResourceField'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'
import type Employee from 'modules/employees/store/models/Employee'
import type { CompanyInstallations } from 'modules/marketplace/store/collections/companyInstallations'
import integrationsDescriptor from 'modules/payroll_integrations/components/IntegrationsDescriptor'

interface ValidatorBlockProps {
  usageGroups: string[]
  fieldableModelRef: string
  fieldableId: number
  valuableModelRef: string
  valuableInstance: Model
  employee?: Employee
  installedIntegrations: CompanyInstallations
  resourceFieldFilter?: (models: ResourceField[]) => ResourceField[]
}

export const ValidatorBlock = ({
  usageGroups,
  fieldableModelRef,
  fieldableId,
  valuableModelRef,
  valuableInstance,
  employee,
  resourceFieldFilter,
  installedIntegrations,
}: ValidatorBlockProps) => {
  const { filteredResourceFields } = useResourceField({
    usageGroups,
    fieldableModelRef,
    fieldableId,
    valuableModelRef,
    valuableInstance,
    employee,
    resourceFieldFilter,
  })

  const integrations = integrationsDescriptor.enabled(installedIntegrations)

  return {
    isPayrollCustomFieldsBlockVisible: filteredResourceFields.length > 0,
    isIrpfVisible: employee ? IsIrpfVisible(employee) : false,
    hasintegrations: integrations.length > 0,
  }
}

export const IsIrpfVisible = (employee: Employee) => {
  const { value } = useAsyncCan('employees.irpf', employee)

  return value
}
